export interface ICounterState {
    click: number;
    viewCount: number;
}

const initialState: ICounterState = {
    click: 0,
    viewCount: 10
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/counter/ICounterState.ts